import { render, staticRenderFns } from "./accountVault.vue?vue&type=template&id=9174cede&scoped=true"
import script from "./accountVault.vue?vue&type=script&lang=js"
export * from "./accountVault.vue?vue&type=script&lang=js"
import style0 from "./accountVault.vue?vue&type=style&index=0&id=9174cede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9174cede",
  null
  
)

export default component.exports